/* global axios */
import ApiClient from './ApiClient';

class AsaasConfigAPI extends ApiClient {
  constructor() {
    super('asaas_config', { accountScoped: true });
  }

  create(config) {
    return axios.post(this.url, { asaas_config: config });
  }

  update(config) {
    return axios.patch(this.url, { asaas_config: config });
  }
}

export default new AsaasConfigAPI();
